import { BlogSection } from '@/types/blog';

export const referenzen: BlogSection = {
  id: 'referenzen',
  title: 'Wissenschaftliche Referenzen',
  content: `
<div class="bg-joerg-50 p-6 rounded-lg mt-8 text-sm text-joerg-700 space-y-2">
  <p><strong>Beaty, R. E., Benedek, M., Silvia, P. J., & Schacter, D. L.</strong> (2016). Creative cognition and brain network dynamics. <em>Trends in Cognitive Sciences, 20</em>(2), 87-95.</p>
  
  <p><strong>Doidge, N.</strong> (2007). <em>The Brain That Changes Itself: Stories of Personal Triumph from the Frontiers of Brain Science.</em> Penguin Books.</p>
  
  <p><strong>Kaplan, S.</strong> (1995). The restorative benefits of nature: Toward an integrative framework. <em>Journal of Environmental Psychology, 15</em>(3), 169-182.</p>
  
  <p><strong>Lee, A., Legood, A., Hughes, D., Tian, A. W., Newman, A., & Knight, C.</strong> (2018). Leadership, creativity and innovation: a meta-analytic review. <em>European Journal of Work and Organizational Psychology, 29</em>(1), 1-35.</p>
  
  <p><strong>Maas, J., Verheij, R. A., de Vries, S., Spreeuwenberg, P., Schellevis, F. G., & Groenewegen, P. P.</strong> (2009). Morbidity is related to a green living environment. <em>Journal of Epidemiology and Community Health, 63</em>(12), 967-973.</p>
  
  <p><strong>Song, C., Ikei, H., & Miyazaki, Y.</strong> (2016). Physiological Effects of Nature Therapy: A Review of the Science and Technology. <em>International Journal of Environmental Research and Public Health, 13</em>(8), 781.</p>
  
  <p><strong>Wilson, E. O.</strong> (1984). <em>Biophilia.</em> Harvard University Press.</p>
</div>
  `,
};
